import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { postsApi } from "../../../../utils";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import Post from "./Post";

const Posts = () => {
    const { texts } = useSelector(state => state.translate);
    const dispatch = useDispatch()

    const applicationId = useSelector(state => state.application.applicationId);
    const [posts, setPosts] = useState()
    const componentMounted = useRef(true);
    const [currentPostPlay, setCurrentPostPlay] = useState();

    useEffect(() => {
        postsApi.postsOffensivePostsFilterRangePost({ applicationId: applicationId }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.errorPosts, error: error, statusCode: response?.statusCode, message: "errorPosts " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                if (componentMounted.current) {
                    setPosts(resdata.map(r => ({ ...r, contentData: r.contentData && JSON.parse(r.contentData) })));
                }
            }
        })

    }, [])

    useEffect(() => {
        return () => {
            componentMounted.current = false;
        }
    }, [])

    const handleRemovePost = (postId) => {
        postsApi.postsDeleteIdPost(postId, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.errorNoPermission, error: error, statusCode: response?.statusCode, message: "errorNoPermission " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                if (componentMounted.current) {
                    setPosts(prev => prev.filter(pf => pf.id !== postId));
                }
            }
        })
    }

    const handleApprovePost = (postId) => {
        postsApi.postsFeedbackDeleteIdPost(postId, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.errorNoPermission, error: error, statusCode: response?.statusCode, message: "errorNoPermission " + error.message, level: 2, component: "CoursesPage", line: 29 }))
            } else {
                if (componentMounted.current) {
                    setPosts(prev => prev.filter(pf => pf.id !== postId));
                }
            }
        })

    }

    return <div>
        {posts && posts.map(p => <Post
            key={p.id}
            currentPostPlay={currentPostPlay}
            setCurrentPostPlay={setCurrentPostPlay}
            p={p}
            play={currentPostPlay && currentPostPlay.id == p.id}
            remove={handleRemovePost}
            approve={handleApprovePost}>
        </Post>
        )}
    </div>
}

export default Posts;

{/* <div>feedback {p.feedbacks[FeedbackTypeTextEnum.offensive].count}</div> */ }
{/* <BtnSelect onClick={()=>handleRemoveFeedback(p.id)}>אשר</BtnSelect> */ }
{/* <BtnSelect checked={true} onClick={()=>handleRemovePost(p.id)}>הסר</BtnSelect> */ }